/*eslint comma-dangle: [2, "always"]*/
export default {
  // Home Screen
  'Select your product': 'Select your product',
  'Upload your receipt': 'Upload your receipt',
  'Register': 'Register',
  'Get your money back': 'Get your money back',
  'Start Refund': 'Start Refund',
  'Terms and Conditions': 'Terms and Conditions',
  'Step': 'Step',
  'Cookie button': 'Cookie button',

  // Language Selector
  'selectLanguage': 'Select language',
  'languageMenu': 'Language menu',
  'language': 'language',
  
  // Navigation
  'toggleMenu': 'Toggle menu',
  
  // Modal openers
  'openDetails': 'Open details',
  'opensDetailsDialog': 'Opens details dialog',
  'closeDialog': 'Close dialog',

  // Barcode page
  'Scan the product': 'Scan the product',
  'Type in or scan the barcode': 'Type in or scan the barcode',
  // BR after stop
  'Please enter the barcode number of your Oral-B product, take a photo of your promotional product or upload it using drag & drop. Please make sure that the barcode information of your promotional product is clearly visible.': `Please enter the serial number and barcode number of your Oral-B toothpaste product, take a photo of your promotional product or upload it using drag & drop.
  <br>
  Please make sure that the barcode information of your promotional product is clearly visible.`,
  'Upload barcode image via drag & drop or from your device folder': 'Upload barcode image via drag & drop or from your device folder',
  'Scan the barcode image': 'Scan the barcode image',
  'Add barcode': 'Add barcode',
  'Barcode number': 'Barcode number',
  'Serial number': 'Serial number',
  'Add': 'Add',
  'Invalid barcode number': 'Invalid barcode number',
  'Upload': 'Upload',
  'Drag & Drop': 'Drag & Drop',
  'Scan': 'Scan',
  'the easiest': '(the easiest)',
  'Unfortunately no valid barcode can be recognized.Please try to enter the barcode in the field above.': 'Unfortunately no valid barcode can be recognized.Please try to enter the barcode in the field above.',
  'Please turn on your camera': 'Please turn on your camera',
  'The barcode number is valid': 'The barcode number is valid',
  'or': 'or',

  // Receipt upload page
  'Upload receipt': 'Upload receipt',
  'Upload a picture of your proof of purchase now.': 'Upload a picture of your proof of purchase now.',
  'Upload your receipt photo using drag and drop. Only JPEG, PDF and PNG are supported. Maximum file size: 16MB.': 'Upload your receipt photo using drag and drop. Only JPEG, PDF and PNG are supported. Maximum file size: 16MB.',
  'Please photograph your proof of purchase!': 'Please photograph your proof of purchase!',
  'Make sure that the following information is clearly visible:': 'Make sure that the following information is clearly visible:',
  'Retailer': 'Retailer',
  'Promotional product and purchase price': 'Promotional product and purchase price',
  'Total of the proof of purchase': 'Total of the proof of purchase',
  'Date and time of purchase': 'Date and time of purchase',
  'Proof of purchase ID': 'Proof of purchase ID',
  'Choose a file': 'Choose a file',
  'Upload your receipt photo': 'Upload your receipt photo',
  'Drag & Drop or click here': 'Drag & Drop or click here',
  'You can erase private information with the razor tool.': 'You can erase private information with the razor tool.',
  'If you get an error message, please take a better version of the receipt and upload it again.': 'If you get an error message, please take a better version of the receipt and upload it again.',
  'The receipt is processed automatically.This can take a minute.Please be patient.': 'The receipt is processed automatically.This can take a minute.Please be patient.',
  'Your receipt will now be uploaded and processed.': 'Your receipt will now be uploaded and processed.',
  'Please drag your receipt into the gray rectangle.': 'Please drag your receipt into the gray rectangle.',
  'Crop': 'Crop',
  'Rub out': 'Rub out',
  'Drag': 'Drag',
  // 'Draw': 'Draw',
  'Zoom in': 'Zoom in',
  'Zoom out': 'Zoom out',
  'Select an Image': 'Select an Image',
  'Select Another': 'Select Another',

  // Product upload page
  'Upload product photo': 'Upload product photo',
  'Upload your receipt photo using drag and drop. Only JPEG and PNG are supported. Maximum file size: 16MB.': 'Upload your receipt photo using drag and drop. Only JPEG and PNG are supported. Maximum file size: 16MB.',
  'Please upload a photo of the front of your Oral-B products with the yellow banner.': 'Please upload a photo of the front of your Oral-B products with the yellow banner.',
  'Please upload a photo of the product page on which the EAN barcode is clearly visible.': 'Please upload a photo of the product page on which the EAN barcode is clearly visible.',

  // IBAN Page
  'What is IBAN and where do I find it?': 'What is IBAN and where do I find it?',
  "IBAN stands for International Bank Account Number. It's an internationally-agreed code made up of up to 34 letters and numbers that helps banks to process transfers around the world. You can usually find your IBAN number on the top right- hand side of your bank statement or in your online banking.If you can't locate your IBAN, you should be able to generate it online via your bank's internet banking service or by using an IBAN calculator tool.": `IBAN stands for International Bank Account Number. It's an internationally-agreed code made up of up to 34 letters and numbers that helps banks to process transfers around the world.
  <br>
  <br>
  You can usually find your IBAN number on the top right- hand side of your bank statement or in your online banking.If you can't locate your IBAN, you should be able to generate it online via your bank's internet banking service or by using an IBAN calculator tool.`,
  'What is BIC and where do I find it?': 'What is BIC and where do I find it?',
  "BIC stands for Bank Identifier Code. To send or receive money, any financial institution must know where to send the money and BIC is exactly what shows it. You can usually find your bank's BIC in your bank account statements.If you're using online banking, log into your digital bank account to easily view your bank statement or contact your bank so that they provide you your BIC.": `BIC stands for Bank Identifier Code. To send or receive money, any financial institution must know where to send the money and BIC is exactly what shows it. You can usually find your bank's BIC in your bank account statements.
  <br>
  <br>
  If you're using online banking, log into your digital bank account to easily view your bank statement or contact your bank so that they provide you your BIC.`,
  'Specify bank details': 'Specify bank details',
  'Please enter the first and last name of the account holder exactly as they were given at the bank.': 'Please enter the first and last name of the account holder exactly as they were given at the bank.',
  'Avoid changing the umlauts: Müller or Mueller. Avoid adding or leaving out hyphens: Marie Luise or Marie-Luise. Only enter the middle name if the account is also managed with it.': 'Avoid changing the umlauts: Müller or Mueller. Avoid adding or leaving out hyphens: Marie Luise or Marie-Luise. Only enter the middle name if the account is also managed with it.',
  'IBAN': 'IBAN',
  'BIC': 'BIC',
  'Account holder first name': 'Account holder first name',
  'Account holder last name': 'Account holder last name',
  'If the data does not exactly match the account details, in most cases the bank will charge back and make the process of an uncomplicated and quick refund more difficult.': 'If the data does not exactly match the account details, in most cases the bank will charge back and make the process of an uncomplicated and quick refund more difficult.',
  'Enter your IBAN': 'Enter your IBAN',
  'Enter your BIC': 'Enter your BIC',
  'Enter your first name': 'Enter your first name',
  'Enter your last name': 'Enter your last name',

  // Register Page
  'Registration form': 'Registration form',
  'We need the following information from you to process the payment. These are only used to process the Oral-B Money-back campaign.': 'We need the following information from you to process the payment. These are only used to process the Oral-B Money-back campaign.',
  'Title': 'Title',
  'Mrs': 'Mrs',
  'Mr': 'Mr',
  'First name': 'First name',
  'Last name': 'Last name',
  'Date of birth': 'Date of birth',
  'E-mail address': 'E-mail address',
  'Streetname': 'Streetname',
  'Number': 'Number',
  'Postal Code': 'Postal Code',
  'City': 'City',
  'Country': 'Country',
  'Personal information': 'Personal information',
  'Address': 'Address',
  'Enter your birth date': 'Enter your birth date',
  'Enter your email': 'Enter your email',
  'Enter your street name': 'Enter your street name',
  'Enter your Postal code': 'Enter your Postal code',
  'Enter your country': 'Enter your country',
  'Enter your house number': 'Enter your house number',
  'Enter your city': 'Enter your city',
  'I confirm that I am over 18 years old. I confirm the terms and conditions, privacy policy & Justsnap privacy policy.': 'I confirm that I am over 18 years old. I confirm the terms and conditions, privacy policy & Justsnap privacy policy.',
  'I have read the conditions of participation for this promotion and accept them.': 'I have read the conditions of participation for this promotion and accept them.',
  'Always up-to-date with our newsletters. You want to receive emails, offers and coupons from Oral-B - the community for power women and super moms - and other trusted P&G brands.': 'Always up-to-date with our newsletters. You want to receive emails, offers and coupons from Oral-B - the community for power women and super moms - and other trusted P&G brands.',
  'Why do we collect this data?': `<div>
                                <b>Why do we collect this data?</b>
                                <br>
                                You are about to register as a user of Oral-B with Procter & Gamble as data controller. By registering, you acknowledge the following:
                                <br>
                                <br>
                                <b>Consent to Email marketing</b>
                                <br>
                                You want to receive emails, offers, and coupons from Oral-B and other trusted P&G brands.
                                <br>
                                <br>
                                <b>Your choices</b>
                                <br>
                                You can exercise your privacy rights or change your settings and subscriptions by clicking here.
                                <br>
                                <br>
                                <b>Terms of Use nad Privacy Policy</b>
                                <br>
                                You are at least 18 years old and have read and agree to the P&G Terms and Conditions and the Privacy Policy. In order to better tailor our communication to your interests, we combine the data that you provide with other possibly collected data from subscription multiple sources and from third-party providers.
                              </div>`,
  'SIGN UP': 'SIGN UP',
  '(optional)': '(optional)',
  'FAQ': 'FAQ',
  'Choose Another': 'Choose Another',
  'Move': 'Move',
  'Enter a city you live': 'Enter a city you live',
  'Choose a country': 'Choose a country',
  'dd/mm/yyyy': 'dd/mm/yyyy',
  'Account information': 'Account information',
  'Create a strong password': 'Create a strong password',
  'Please fill in your email address, and we will send you a reset link.': 'Please fill in your email address, and we will send you a reset link.',
  'Copied to clipboard': 'Copied to clipboard',
  'Copy to clipboard': 'Copy to clipboard',
  bannerAltText: '60 DAYS BUY AND TRY GUARANTEE - FULL SATISFACTION OR MONEY BACK - Oral-B - #1 The toothbrush brand recommended by most dentists worldwide',
  productBackSideAltText: 'Image of product back side showing barcode location',
  reclaimImageAltText: 'Illustration of money-back process',

  // SMS Pages
  'Please confirm your identity': 'Please confirm your identity',
  'In order to check your identity, we need your mobile phone number. The specification of the mobile number is required to verify your participation. The phone number you provide will only be used for one-time, advertising-free verification and will be deleted by us after the campaign.': 'In order to check your identity, we need your mobile phone number. The specification of the mobile number is required to verify your participation. The phone number you provide will only be used for one-time, advertising-free verification and will be deleted by us after the campaign.',
  'Please enter your mobile number in the field below. We will then send you a code to confirm your participation via SMS, which you can then enter on the next page.': 'Please enter your mobile number in the field below. We will then send you a code to confirm your participation via SMS, which you can then enter on the next page.',
  '(Prefix like +49, +90)': '(Prefix like +49, +90)',
  'Mobile number': 'Mobile number',
  'Please enter the confirmation code that we sent you via SMS into the field.': 'Please enter the confirmation code that we sent you via SMS into the field.',
  'Confirmation code': 'Confirmation code',
  'Change mobile number': 'Change mobile number',

  // Thank you page
  'Thank you for your participation': 'Thank you for your participation',
  'Your receipt and your data have been successfully sent to us and are now being checked.': 'Your receipt and your data have been successfully sent to us and are now being checked.',
  'Reference number:': 'Reference number:',
  'As soon as we have checked your data, you will either receive a confirmation e-mail or an e-mail with queries if your data was incomplete or your proof of purchase could not be recorded. This can take up to 36 hours. We ask for your patience. After successfully checking the proof of purchase and all other data as well as succesfully receiving the product you would like to return, we will transfer the reimbursement amount to the account you specified within 6 weeks. If anything is unclear, we will contact you again by email.': `As soon as we have checked your data, you will either receive a confirmation e-mail or an e-mail with queries if your data was incomplete or your proof of purchase could not be recorded. This can take up to 36 hours. We ask for your patience.
  <br>
  <br>
  After successfully checking the proof of purchase and all other data as well as succesfully receiving the product you would like to return, we will transfer the reimbursement amount to the account you specified within 6 weeks. If anything is unclear, we will contact you again by email.`,

  // Survey page
  'What were the main reasons for you to buy this product?': 'What were the main reasons for you to buy this product?',
  'Please select as applicable': 'Please select as applicable',
  'Easy to use': 'Easy to use',
  'Design': 'Design',
  'Price / good deal': 'Price / good deal',
  'Performance': 'Performance',
  'Other': 'Other',
  'Why would you like to return the product?': 'Why would you like to return the product?',
  "It doesn't work as expected": '',
  'Wrong item size or wrong product': 'Wrong item size or wrong product',
  'Changed mind after Product Purchased': 'Changed mind after Product Purchased',
  "Product didn't match the website or catalog Description": '',
  'Found better product price elsewhere': 'Found better product price elsewhere',
  'Product did not meet my expectations': 'Product did not meet my expectations',

  // Return form page
  'Product name': 'Product name',
  'Product EAN Number': 'Product EAN Number',
  'Product Serial Number': 'Product Serial Number',
  'Product Price for Money-back': 'Product Price for Money-back',
  'Date of purchase': 'Date of purchase',
  'Time of purchase': 'Time of purchase',
  'Retailer Name': 'Retailer Name',
  'Receipt/Invoice ID': 'Receipt/Invoice ID',
  'Reference number of the participation': 'Reference number of the participation',
  'Enter Product name': '',
  'Enter Product EAN Number': '',
  'Enter Product Serial Number': '',
  'Enter Product Price for Money-back': '',
  'Enter Date of purchase': '',
  'Enter Time of purchase': '',
  'Enter Retailer Name': '',
  'Enter Receipt/Invoice ID': '',
  'Enter Reference number of the participation': '',

  // Reclaim page
  'Ready': '',
  'Thank you for the message.': '',
  'We will check the reimbursement amount again and then inform you. The verification may take some time, so we ask for your patience.': '',

  // Error page
  'Oops!!': 'Oops!!',
  'Something went wrong!': '',

  // Expired page
  'Unfortunately the link is no longer valid!': 'Unfortunately the link is no longer valid!.',
  'Please participate again or contact our support team: contact@oral-b-moneyback.com': 'Please participate again or contact our support team: <a href="mailto:contact@oral-b-moneyback.com><u>contact@oral-b-moneyback.com</u></a>',

  // Campaign is over page
  'The campaign period is over': '',
  'Thank you for your interest in the campaign, unfortunately the campaign period is over.': '',

  // Reupload pages
  'Re-Upload your receipt': 'Re-Upload your receipt',
  'Re-Upload product photo': 'Re-Upload product photo',
  'Thank you': 'Thank you',
  'Thank you for resubmitting your bank details.': 'Thank you for resubmitting your bank details.',
  'So nothing should stand in the way of a successful transfer.': 'So nothing should stand in the way of a successful transfer.',
  "If you have any questions related to your bank details, please contact <a href='mailto:support@oral-b-moneyback.com'><b>support@oral-b-moneyback.com</b></a>.": "If you have any questions related to your bank details, please contact <a href='mailto:support@oral-b-moneyback.com'><b>support@oral-b-moneyback.com</b></a>.",
  "For other concerns, you can contact our support service at <a href='mailto:contact@oral-b-moneyback.com'><b>contact@oral-b-moneyback.com</b></a>.": "For other concerns, you can contact our support service at <a href='mailto:contact@oral-b-moneyback.com'><b>contact@oral-b-moneyback.com</b></a>.",

  // Extra
  'Back': 'Back',
  'Next': 'Next',
  'Back to the Oral-B website': 'Back to the Oral-B website',
  'Back to the homepage': 'Back to the homepage',
  'Send': 'Send',
  'Please hide your personal data (name, surname, phone nr., address, etc.) on the receipt/invoice if you will have it before sending your package to Service Center.': '',

  // Validation
  'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.': 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
  'There is currently a problem with our website. Please try again in a few minutes.': 'There is currently a problem with our website. Please try again in a few minutes.',
  'The file is too big. Only files up to 16 MB are supported.': 'The file is too big. Only files up to 16 MB are supported.',
  'Oops. An error has occurred. Please try again later.': '',
  validation: {
    mandatory: 'This field is required.',
    required: "The {field} field is required",
    iban: 'IBAN - Please use a valid IBAN number in the format: XX00 0000 0000 0000 00 (country code + digits)',
    postal: '',
    bic: 'BIC must be in the correct format (e.g. DABADKKK)',
    mobileNumber: '',
    email: 'Please enter a valid email address in the format: name@example.com',
    customRequired: {
      'Mobile number': 'The mobile number field is mandatory',
      code: 'The sms code field is mandatory',
      'E-mail address': 'Please enter a valid email address in the format: name@example.com',
      'IBAN': 'IBAN - Please use a valid IBAN number in the format: XX00 0000 0000 0000 00 (country code + digits)',
      'BIC': 'BIC must be in the correct format (e.g. DABADKKK)',
    },
  },
}
